<script>
import DashboardIcon from 'shared/components/FluentIcon/DashboardIcon.vue';
import Logo from './Logo.vue';

export default {
  components: { DashboardIcon, Logo },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<template>
  <div
    class="flex items-center gap-2 flex-shrink-0 h-16"
    :class="[
      !isACustomBrandedInstance ? 'border-b border-primary-900/40' : '',
      isCollapsed ? 'justify-center px-2' : 'justify-between px-3',
    ]"
  >
    <Logo
      v-if="!isCollapsed"
      :source="logoSource"
      :name="installationName"
      :account-id="accountId"
    />
    <!-- O mesmo icone nos dois estados, e nao uma seta que vira de lado: o
         desenho ja mostra de que lado esta o painel, e o que o botao faz e
         mostrar ou esconder AQUELE painel. Seta apontando para a esquerda ou
         para a direita e uma segunda leitura ("vai para onde?") que o icone de
         painel dispensa.

         Botao cru em vez de `woot-button`: ele monta o icone pelo
         `EmojiOrIcon`, um componente deprecado que nao repassa `view-box`.
         Sem ele o desenho da grade de 20 sairia a 83% e fora de centro.

         `p-0` nao e enfeite: a folha global da `<button>` um padding de
         0.25rem 0.5rem, e com `border-box` sobram 16px de largura util
         dentro dos 32px do botao. O SVG e item flex, encolhe para caber e
         sai encolhido -- medido na pagina: caixa 14x24 num botao de 32x32. Era esta a razao de o icone parecer menor que os
         da navegacao, que sao `<a>` e nao herdam esse padding.

         A cor e `text-primary-100`, a MESMA dos itens da navegacao
         (rgb(176,214,255), medido na pagina). `text-white/80` dava um branco
         acinzentado, mais claro e de outro tom que os vizinhos. -->
    <button
      type="button"
      class="flex items-center justify-center flex-shrink-0 w-8 h-8 p-0 transition-colors rounded-md text-primary-100 hover:text-white hover:bg-white/10"
      :aria-label="$t('KEYBOARD_SHORTCUTS.TITLE.TOGGLE_SIDEBAR')"
      :aria-expanded="(!isCollapsed).toString()"
      @click="$emit('toggleSidebar')"
    >
      <!-- 20, como todo icone da navegacao: o desenho e da grade de 20 do
           Fluent, entao a 20px uma unidade vale um pixel e todo traco cai
           inteiro numa coluna. Na grade de 24 ele sairia a 0.83px por
           unidade, repartido em duas colunas cinzas. -->
      <DashboardIcon icon="panel-left" size="20" view-box="0 0 20 20" />
    </button>
  </div>
</template>
